import * as React from 'react';
import carouselReducer from '../reducers/carouselReducer';

const initialState = { currentIndex: 0, isPlaying: true };
const SLIDE_DURATION = 10000;

function useCarousel(count) {
  const [state, dispatch] = React.useReducer(carouselReducer, initialState);
  React.useEffect(() => {
    let timeout;
    if (state.isPlaying) {
      timeout = setTimeout(() => {
        dispatch({ type: "PROGRESS", payload: count });
      }, SLIDE_DURATION);
    }
    return (): void => clearTimeout(timeout);
  }, [state.currentIndex, state.isPlaying, count]);
  return [
    state,
    { 
      handleNext: (): void => dispatch({ type: "NEXT", payload: count }),
      handlePrev: (): void => dispatch({ type: "PREV", payload: count }),
      handlePlay: (): void => dispatch({ type: "PLAY" }),
      handlePause: (): void => dispatch({ type: "PAUSE" }),
      handleGoTo: (index): void => dispatch({ type: "GOTO", index }),
    }
  ];
}

export default useCarousel;